module.exports = __webpack_public_path__ + "static/media/auric-nature.b04104fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/group logos/auric-nature.svg
// module id = 66
// module chunks = 0